/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 4/19/2022
 * Time: 6:05 PM
 * Project: w_crm
 */
import React from "react";
import "./style.css";
import userObserver from "../../../utils/userObserver";
import Button from "../../../component/Button/Button";
import MenuHolder from "../../../component/MenuHolder/MenuHolder";
import {Breadcrums} from "./BreadCrums";

export default function NavAction({actionListData = []}) {
    const [matches, ref] = userObserver();

    const ControlItems = () => {
        return actionListData.filter(j => j?.name).map((i) => {
            const {icon: Icon} = i;
            return {...i, icon: <Icon strokeWidth={2} className="w-1-5"/>};
        });
    };

    return (
        <div className="action-slot" ref={ref}>
            <Breadcrums/>
            {actionListData.length > 0 ? (
                <>
                    {matches.mobile || matches.tablet ? (
                        <MenuHolder menuItems={ControlItems()}/>
                    ) : (
                        <div className={"nav-action-desktop-holder"}>
                            {actionListData.map((item, index) => {
                                if (item?.name) {
                                    // Stable key — getUUID() remounted filters/actions every render
                                    return (
                                        <Button
                                            disabled={!item.isEnabled}
                                            key={`navaction-${item.id ?? index}`}
                                            onClick={item.action}
                                        >
                                            <span className="nav-action-item-label">{item.name}</span>
                                            {item.disabledHint && (
                                                <span className="nav-action-item-hint">
                                                    {item.disabledHint}
                                                </span>
                                            )}
                                        </Button>
                                    );
                                } else {
                                    return (
                                        <React.Fragment key={`nav-custom-${index}`}>
                                            {item}
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </div>
                    )}
                </>
            ) : (
                <>
                    {actionListData.map((item, index) => {
                        return (
                            <React.Fragment key={`nav-empty-${index}`}>
                                {item}
                            </React.Fragment>
                        );
                    })}
                </>
            )}
        </div>
    );
}
